import { render } from "./print-sales-receipt.vue?vue&type=template&id=e0f6a6c4"
import script from "./print-sales-receipt.vue?vue&type=script&lang=js"
export * from "./print-sales-receipt.vue?vue&type=script&lang=js"

import "./print-sales-receipt.vue?vue&type=style&index=0&id=e0f6a6c4&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__